import { createWebHistory, createRouter } from "vue-router";
import routes from './routes';
import appConfig from "../../app.config";
import store from '../state/store';
//import SubscriptionService from "../services/SubscriptionService";

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

// API based Authentication
// Correction du routeur
router.beforeEach(async (routeTo, routeFrom, next) => {
  // Instance du service
 // let subscriptionService = new SubscriptionService();
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  /*// 1. Gérer la redirection des utilisateurs sans abonnement
  // On s'assure que l'utilisateur n'est pas déjà sur la page "sans abonnement" pour éviter une boucle de redirection
  if (routeTo.path !== '/no-subscription' && authRequired) {
    let isSubscribed = await subscriptionService.checkSubscription();
    if (!isSubscribed) {
      return next("/no-subscription"); // Un seul appel à next()
    }
  }*/

  // 2. Gérer l'authentification
  if (!authRequired) {
    return next();
  }

  if (store.state.currentUser === null) {
    // Si l'utilisateur n'est pas connecté, rediriger vers la page de connexion
    return next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
  } else {
    // Si l'utilisateur est connecté et activé, continuer la navigation
    if (store.state.currentUser.enabled === true) {
      return next();
    } else {
      return next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    }
  }
});

// Supprimer la deuxième garde de navigation si sa logique est déjà gérée dans la première
router.beforeEach((routeTo, routeFrom, next) => {
  const publicPages = ['/login', '/register', '/forgot-password', '/landing', '/logout', '/register/step2/:user'];
  const authPage = !publicPages.includes(routeTo.path);
  const loggedUser = localStorage.getItem('currentUser');

  if (routeTo.name === 'register2') {
    return next();
  }

  if (authPage && !loggedUser) {
    return next('/login');
  }

  const user = store.state.currentUser;

  if (routeTo.meta.authRequired === true) {
    if (user.type.nom === 'Super Admin' || user.type.permissions.some(p => p === routeTo.meta.key)) {
      return next();
    } else {
      return next({ name: 'Unauthorized' });
    }
  } else {
    return next();
  }
});
router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error('Redirected'));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  document.title = routeTo.meta.title + ' | ' + appConfig.title;
  next();
});

export default router;
